export class HeaderMenusService {
	constructor($resource, ApiService) {
		'ngInject';

		this.$resource = $resource;
		this.apiService = ApiService;

		this.menusResourceUrl = this.apiService.getResourceUrl('menus');

		this.menusResource = this.$resource(this.menusResourceUrl);
	}

	_getMenusDetailObject(details) {
		return details.map((data) => {
			return {
				menuId: data.menu_id,
				parentId: data.parent_id,
				name: data.name,
				displayName: data.display_name,
				isHovered: false,
				isClicked: false,
				isMenuActive: false,
				slug: data.slug,
				subfeature: data.children ? this._getChildrenObject(data.children) : []
			}
		});
	}

	_getChildrenObject(details) {
		return details.map((data) => {
			return {
				menuId: data.menu_id,
				parentId: data.parent_id,
				name: data.name,
				displayName: data.display_name,
				isMenuActive: false,
				slug: data.slug,
				subfeature: data.children ? this._getChildrenObject(data.children) : []
			}
		});	
	}

	/**
	 * function to get menu list
	 * @return {object} [information related to menus]
	 */
	getMenuList() {
		const promise = this.menusResource.get().$promise;

		return promise.then((details) => {
			return this._getMenusDetailObject(details.data); 
		}).catch((error) => {
			throw this.apiService.getErrorMessage(error);
		});
	}
}


// WEBPACK FOOTER //
// ./src/app/common/header-menus/header-menus.service.js